import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";

interface T {
  onConfirm?: () => void;
  onCancel?: () => void;
}
interface Props<T> {
  isOpen: boolean;
  config: T;
}

const ModalNotResponse = ({ isOpen, config }: Props<T>) => {
  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} onCancel={config.onCancel} hideCloseButton>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            ¿Deseas pasar esta pregunta sin responder?
          </h2>
          <p className="text-center text-color-02">
            No podrás regresar a la pregunta anterior después de continuar.
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons flex-wrap">
          <Button
            type="outline"
            color="primary"
            text="No, regresar"
            data-testid="btn-cancel"
            onClick={config.onCancel}
          />

          <Button
            color="primary"
            text="Sí, continuar"
            data-testid="btn-confirm"
            onClick={config.onConfirm}
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalNotResponse;
